"use client";

import { ReactNode } from "react";

interface FormStepProps {
  children: ReactNode;
  isActive: boolean;
  stepNumber: number;
}

export default function FormStep({
  children,
  isActive,
  stepNumber: _stepNumber,
}: FormStepProps) {
  if (!isActive) return null;

  return (
    <div
      className="transition-all duration-300 ease-in-out"
      style={{
        animation: "fadeInSlide 0.3s ease-in-out",
      }}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
 @keyframes fadeInSlide {
 from {
 opacity: 0;
 transform: translateX(10px);
 }
 to {
 opacity: 1;
 transform: translateX(0);
 }
 }
 `,
        }}
      />
      {children}
    </div>
  );
}
